module.exports = __webpack_public_path__ + "img/crc-04.738b9d7f.jpg";